import { createStyles } from "@mantine/core";
import { tokens } from "@blurb/codex-react";

export const useNavBarButtonStyles = createStyles(() => ({
  navButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: tokens.spacing[3],
    gap: tokens.spacing[2],
    width: 48,
    height: 48,
    borderRadius: tokens.radius.sm,
    textDecoration: "none",
    flexDirection: "row",
    color: tokens.color.semantic.text.bold,
    backgroundColor: "transparent",
    transition: "all 0.2s ease",
    overflow: "hidden",
    "&:focus-visible": {
      outline: `2px solid ${tokens.color.semantic.border.focus}`,
      outlineOffset: "2px",
    },
    "nav:hover &, nav:has(:focus-visible) &, nav:has([aria-expanded='true']) &": {
      width: "100%",
    },
  },
  navButtonText: {
    whiteSpace: "nowrap",
    opacity: 0,
    transition: "opacity 0.2s ease",
    "nav:hover &, nav:has(:focus-visible) &, nav:has([aria-expanded='true']) &": {
      opacity: 1,
    },
  },
}));
